<template>
  <transition-group
    tag="div"
    name="cg-toast-transition-from-left"
    class="cg-toast-container"
    :style="containerStyles"
  >
    <cg-toast-container-item
      v-for="toastItem in itemsToDisplay"
      :key="toastItem.id"
      :toastItem="toastItem"
      :timeout="timeout"
      :html="toastItem.html"
      @dismiss="dismissItem"
    />
  </transition-group>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { ToastItem } from './types';

import CgToastContainerItem from './CgToastContainerItem.vue'

export default Vue.extend({
  name: 'CgToastContainer',
  components: { CgToastContainerItem },
  props: {
    // TODO type class
    toastApi: {
      type: Object,
      required: false,
      default: null,
    },
    allowMultiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    maxItems: {
      type: Number,
      required: false,
      default: 5,
    },
    timeout: {
      type: Number,
      required: false,
      default: 3500,
    },
    // TODO?
    position: {
      type: String, // change to Union
      required: false,
      default: 'bottom-left',
    },
    left: {
      type: Number,
      required: false,
      default: 44,
    },
    right: {
      type: Number,
      required: false,
      default: 44,
    },
    top: {
      type: Number,
      required: false,
      default: 38,
    },
    bottom: {
      type: Number,
      required: false,
      default: 38,
    },
  },
  computed: {
    containerStyles(): Object {
      const { top, left, bottom, right } = this;

      return {
        '--container-top': `${top}px`,
        '--container-left': `${left}px`,
        '--container-bottom': `${bottom}px`,
        '--container-right': `${right}px`,
      };
    },
    toastApiItems (): ToastItem[] {
      return this.toastApi.itemsList as ToastItem[] ?? []
    },
    itemsToDisplay (): ToastItem[] {
      const { toastApiItems, allowMultiple, maxItems } = this

      if (!allowMultiple) return toastApiItems.slice(0, 1)

      return toastApiItems.slice(0, maxItems)
    },
  },
  methods: {
    dismissItem(id: number | string): void {
      this.toastApi.dismiss(id);
    },
  },
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
